export const api_url = process.env.REACT_APP_API_URL

export const urls = {
    userUrl: api_url + "/users",
    qualifiesUrl: api_url + "/qualifies",
    teamUrl: api_url + "/team",
    contactUrl: api_url + "/contacts",
    adsetUrl: api_url + "/adset",
    adUrl: api_url + "/ad",
    campaignUrl: api_url + "/campaign",
    formUrl: api_url + "/form",
    pageUrl: api_url + "/page",
    userroleUrl: api_url + "/userrole",
    workflowUrl: api_url + "/workflows",
    countryUrl: api_url + "/country",
    monthUrl: api_url + "/month",
    profileUrl: api_url + "/profile",
    reasonUrl: api_url + "/reason",
    preferredintakeUrl: api_url + "/preferredintake",
    educationalstatusUrl: api_url + "/educationalstatus",
    categorystudyUrl: api_url + "/categorystudy",
    interestedlevelUrl: api_url + "/interestedlevel",
    englishtestUrl: api_url + "/englishtest",
    interestedcountryUrl: api_url + "/interestedcountry",
    helpUrl: api_url + "/help",
    interestedfieldofstudyUrl: api_url + "/interestedfieldofstudy",
    emaillogUrl: api_url + "/emaillog",
    notelogUrl: api_url + "/notelog",
    calllogUrl: api_url + "/calllog",
    outcomeUrl: api_url + "/outcome",
    taskUrl: api_url + "/task",
    pipelineUrl: api_url + "/pipeline",
    dealstageUrl: api_url + "/dealstage",
    dealUrl: api_url + "/deal",
    studybatchUrl: api_url + "/studybatch",
    studybatchcUrl: api_url + "/sbcm",
    calloutcomeUrl: api_url + "/calloutcome",
    extrasUrl: api_url + "/extras",
    activitiesUrl: api_url + "/activities",
    notificationsUrl: api_url + "/notifications",
    leadsourceUrl: api_url + "/leadsource",
    lifecycleUrl: api_url + "/lifecycle",
    bookingUrl: api_url + "/booking",
    mailsettingsUrl: api_url + "/mailsettings",
    priorityUrl: api_url + "/priority",
    contactratingUrl: api_url + "/contactrating",
    enquiryforUrl: api_url + "/enquiryfor",
    financialsourceUrl: api_url + "/financialsource",
    genderUrl: api_url + "/gender",
    maritalstatusUrl: api_url + "/maritalstatus",
    howyouheardaboutusUrl: api_url + "/howyouheardaboutus",
    meetingtypeUrl: api_url + "/meetingtype",
    branchUrl: api_url + "/branch",
    referralUrl: api_url + "/referral",
    subagentUrl: api_url + "/subagent",
    courseUrl: api_url + "/courses",
    universityUrl: api_url + "/university",
    partneragentUrl: api_url + "/partneragent",
    affiliatepartnerUrl: api_url + "/affiliatepartner",
    currencyUrl: api_url + "/currency",
    otherreferralUrl: api_url + "/otherreferral",
    contactnotificationUrl: api_url + "/contactnotification",
    contactmessagesUrl: api_url + "/contactmessages",
    applicationUrl: api_url + "/applications",
    shortlistcourseUrl: api_url + "/shortlistcourse",
    confirmationofacceptanceUrl: api_url + "/confirmationofacceptance",
    applicationstatusUrl: api_url + "/applicationstatus",
    offeracceptedUrl: api_url + "/offeraccepted",
    uploadUrl: api_url + "/upload",
    uploadsUrl: api_url + "/uploads",
    campusUrl: api_url + "/campus",
    departmentUrl: api_url + "/department",
    hierarchyUrl: api_url + "/hierarchy",
    documentUrl: api_url + "/document",
    websitepageUrl: api_url + "/websitepage",
    documentsubsectionUrl: api_url + "/documentsubsection",
    eventUrl: api_url + "/event",
    eventmediumUrl: api_url + "/eventmedium",
    eventregistrationUrl: api_url + "/eventregistration",
    seclientUrl: api_url + "/seclient",

    accountingusersUrl: api_url + "/accounts/users",
    invoiceUrl: api_url + "/accounts/invoice",
    invoicetypeUrl: api_url + "/accounts/invoicetype",
    invoicedetailsUrl: api_url + "/accounts/invoicedetails",
    // invoiceremainderUrl: api_url + "/accounts/invoiceremainder",
    // invoicenotificationUrl: api_url + "/accounts/invoicenotification"
}